// The `SecondaryBannerTastic` component is a React component that integrates with the
// `SecondaryBanner` component to render a secondary banner section. It receives its data through the
// `TasticProps` interface, extracts the `dataSource` from the provided `SecondaryBannerTasticData`,
// and passes it to `SecondaryBanner` for display. This design allows for dynamic rendering of banners based on
// the data provided.

'use client';

import SecondaryBanner from 'components/commercetools-ui/organisms/content/homepage-secondary-banner';
import React from 'react';
import { TasticProps } from '../types';
import { SecondaryBannerTasticData } from 'types/next';

const SecondaryBannerTastic = ({ data }: TasticProps<SecondaryBannerTasticData>) => {
  return (
    <>
      <div>
        <SecondaryBanner content={data?.data?.dataSource?.images} />
      </div>
    </>
  );
};

export default SecondaryBannerTastic;
